// Lightweight analytics wrapper for GA4 + Meta Pixel
// Fires events to both providers when available

export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;

    // Google Analytics 4
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }

    // Meta Pixel — map to standard or custom events
    if (typeof window.fbq === "function") {
      const standardEvents = ["Lead", "CompleteRegistration", "Subscribe", "Contact", "InitiateCheckout"];
      const fbEvent = params.fb_event || (standardEvents.includes(params.fb_event_type) ? params.fb_event_type : null);
      if (fbEvent) {
        window.fbq("track", fbEvent, params);
      } else {
        window.fbq("trackCustom", eventName, params);
      }
    }
  } catch (e) {
    // never let analytics break the UI
    // eslint-disable-next-line no-console
    console.debug("trackEvent error", e);
  }
}

export function trackCTA(label, location, extra = {}) {
  trackEvent("cta_click", { cta_label: label, cta_location: location, ...extra });
}
